export enum ApplicationEnum {
    NovaWeb = 8
}
